import moment from 'moment';

export default (value) => moment(value).fromNow();



// WEBPACK FOOTER //
// ./sources/filters/now.js